/**
 * @file index.tsx
 *
 * @fileoverview Populates script with provided content.
 *  Only the content admin sets this so we can trust that content is not harmful.
 */
import React from 'react';
import { useClientScriptInsert } from '~/jobiqo/hooks/useClientScriptInsert';

interface BlogInsecureScriptProps {
  /**
   * The bundle name.
   */
  bundle: string;
  /**
   * The row element (from the backend landing page row).
   */
  scriptContent: string;
  /**
   * A unique row identifier for the row.
   */
  index: number;
}

const BlogInsecureScript = ({
  index,
  scriptContent,
  bundle,
}: BlogInsecureScriptProps) => {
  const { strippedJsString } = useClientScriptInsert({
    content: scriptContent ?? '',
    id: `${bundle}-${index}`,
    identifier: 'blog',
  });

  return scriptContent ? (
    <div
      dangerouslySetInnerHTML={{
        __html: strippedJsString ?? '',
      }}
    />
  ) : null;
};

export default BlogInsecureScript;
